import { Routing } from "helpers/routing";
import React, { createContext } from "react";

const SportsmanDatasourceIdentifierContext = createContext<{
  params?: Routing.SportsmanDatasourceIdentifierParams
}>({})

export { SportsmanDatasourceIdentifierContext }
